import BreadCrumb from "Components/Common/BreadCrumb";
import React, { useMemo } from "react";
import { Container, Row } from "reactstrap";
// import Widgets from "./Components/Widgets";
import ManageUsersTable from "./Components/ManageUsersTable";
import { usersWidgetsDetails } from "endpoints/users/usersListingspage.action";
import { useQuery } from "@tanstack/react-query";
import { usersWidgetsData } from "common/data/users";
import Widgets from "Components/Common/Widgets";
// User Listing Page
const Users = () => {
  document.title = "Users";

  const { data: usersDynamicWidgetsData, isPending, isError } = useQuery({
    queryKey: ['usersWidgets'],
    queryFn: usersWidgetsDetails,
    staleTime: 0,
    gcTime: 0,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: false,
    retry: 3,
  });

  // Transform API data to widget format
  const dynamicWidgets = useMemo(() => {
    if (!usersDynamicWidgetsData?.data) {
      return usersWidgetsData; // Return static data as fallback
    }

    const apiData = usersDynamicWidgetsData.data;

    // Helper function to format numbers with commas
    const formatNumber = (num: number | string | undefined): string => {
      if (!num) return "0";
      const numValue = typeof num === 'string' ? parseInt(num) : num;
      return numValue.toLocaleString('en-IN'); // Indian formatting with commas
    };

    return [
      {
        id: 1,
        icon: "ri-building-4-line",
        label: "Total Users",
        counter: formatNumber(apiData.total_customers),
        badge: "ri-arrow-up-s-fill",
        badgeColor: "success",
        percentage: "6.24",
        decimal: "2",
        prefix: "",
        separator: ",",
      },
      {
        id: 2,
        icon: "ri-check-fill",
        label: "Approved",
        counter: formatNumber(apiData.approved_customers),
        badge: "ri-arrow-up-s-fill",
        badgeColor: "success",
        percentage: "3.67",
        decimal: "2",
        prefix: "",
        separator: ",",
      },
      {
        id: 3,
        icon: "ri-error-warning-line",
        label: "Pending",
        counter: formatNumber(apiData.pending_customers),
        percentage: "4.80",
        decimal: "2",
        prefix: "",
        separator: ",",
      },
      {
        id: 4,
        icon: "ri-error-warning-line",
        label: "Rejected",
        counter: formatNumber(apiData.rejected_customers),
        percentage: "4.80",
        decimal: "2",
        prefix: "",
        separator: ",",
      },
    ];
  }, [usersDynamicWidgetsData]);

  // Show loading state
  if (isPending) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // Show error state  
  if (isError) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="text-center">
          <div className="text-danger mb-3">
            <i className="ri-error-warning-line" style={{ fontSize: '3rem' }}></i>
          </div>
          <h5 className="text-danger">Failed to load builder data</h5>
          <p className="text-muted">Please refresh the page to try again.</p>
        </div>
      </div>
    );
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb 
            title="Users" 
            pageTitles={[
              { label: "RealWealtdy", path: "/" },
              { label: "Users" }
            ]}
          />
          <Row>
            <Widgets data={dynamicWidgets} />
          </Row>
          <ManageUsersTable />
        </Container>
      </div>
    </React.Fragment>
  );
};
export default Users;
